import bem from '../../../utils/bem';

const Star = ({
  index,
  baseFillColor = '#EDE8E0',
  accentFillColor = '#FF8300',
  strokeColor,
  fillOffset = 0,
  className,
  srId,
}) => {
  const offsetValue = (1 - fillOffset) * 100;
  const clipPathId = `${srId ? `${srId}-` : ''}cut-off-star-${index}`;
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={bem('a-star', [], '', [className])}
    >
      <defs>
        <clipPath id={clipPathId}>
          <rect x={`-${offsetValue}%`} y="0" width="18" height="17" />
        </clipPath>
      </defs>
      <path
        d="M16.7364 5.89555L11.7774 5.17484L9.56061 0.680702C9.50006 0.557655 9.40045 0.458046 9.2774 0.397499C8.96881 0.245155 8.59381 0.372108 8.43951 0.680702L6.22272 5.17484L1.26373 5.89555C1.12701 5.91508 1.00201 5.97953 0.90631 6.07719C0.79061 6.19611 0.726854 6.35609 0.729051 6.52199C0.731249 6.6879 0.799219 6.84614 0.918028 6.96195L4.50592 10.46L3.65826 15.3995C3.63838 15.5144 3.6511 15.6325 3.69497 15.7406C3.73883 15.8486 3.81209 15.9422 3.90644 16.0107C4.00079 16.0793 4.11246 16.12 4.22877 16.1283C4.34508 16.1366 4.46139 16.1121 4.56451 16.0577L9.00006 13.7256L13.4356 16.0577C13.5567 16.1221 13.6973 16.1436 13.8321 16.1202C14.1719 16.0616 14.4005 15.7393 14.3419 15.3995L13.4942 10.46L17.0821 6.96195C17.1797 6.86625 17.2442 6.74125 17.2637 6.60453C17.3165 6.26273 17.0782 5.94633 16.7364 5.89555Z"
        fill={baseFillColor}
        stroke={strokeColor}
      />
      <path
        d="M16.7364 5.89555L11.7774 5.17484L9.56061 0.680702C9.50006 0.557655 9.40045 0.458046 9.2774 0.397499C8.96881 0.245155 8.59381 0.372108 8.43951 0.680702L6.22272 5.17484L1.26373 5.89555C1.12701 5.91508 1.00201 5.97953 0.90631 6.07719C0.79061 6.19611 0.726854 6.35609 0.729051 6.52199C0.731249 6.6879 0.799219 6.84614 0.918028 6.96195L4.50592 10.46L3.65826 15.3995C3.63838 15.5144 3.6511 15.6325 3.69497 15.7406C3.73883 15.8486 3.81209 15.9422 3.90644 16.0107C4.00079 16.0793 4.11246 16.12 4.22877 16.1283C4.34508 16.1366 4.46139 16.1121 4.56451 16.0577L9.00006 13.7256L13.4356 16.0577C13.5567 16.1221 13.6973 16.1436 13.8321 16.1202C14.1719 16.0616 14.4005 15.7393 14.3419 15.3995L13.4942 10.46L17.0821 6.96195C17.1797 6.86625 17.2442 6.74125 17.2637 6.60453C17.3165 6.26273 17.0782 5.94633 16.7364 5.89555Z"
        fill={accentFillColor}
        stroke={strokeColor}
        clipPath={`url(#${clipPathId})`}
      />
    </svg>
  );
};

export default Star;
